document.addEventListener("DOMContentLoaded", function () {
        var accordionHeaders = document.querySelectorAll(".accordion-header");

        accordionHeaders.forEach(function (header) {
          header.addEventListener("click", function () {
            var content = this.nextElementSibling;
            var chevron = this.querySelector(".chevron");

            // Toggle the open class to rotate the chevron
            this.classList.toggle("open");

            // Toggle the display of the content
            if (content.style.display === "block") {
              content.style.display = "none";
            } else {
              content.style.display = "block";
            }
          });
        });
      });

document.addEventListener("DOMContentLoaded", function() {
  // Check if the current URL path is not '/pages/bulk-order-form'
  if (window.location.pathname !== '/pages/bulk-order-form') {
    var element = document.querySelector('.nm-noborder');
    var nmSaleTable = document.querySelector('.nm-easywholesale-table');
    var nmSaleItems = document.querySelectorAll('.nm-easywholesale-item');
    var nmLayoutBrColor = document.querySelector('.nm-layout-border-color');
    var nmBackground = document.querySelector('.nm-wholesale-background')

      var nmDec = document.querySelectorAll('.nm-easywholesale-qty-decrease')
      var nmIn = document.querySelectorAll('.nm-easywholesale-qty-increase')

    nmLayoutBrColor.style.borderColor = 'current'
     
    if (nmBackground) {
          nmBackground.style.setProperty('background-color', '#fff', 'important'); // Overrides existing !important rule
    }

    // Apply styles to nmDec
    nmDec.forEach(function(element) {
        element.style.setProperty('display', 'block', 'important');
        element.style.setProperty('height', '100%', 'important');
    });
    
    // Apply styles to nmIn
    nmIn.forEach(function(element) {
        element.style.setProperty('display', 'block', 'important');
        element.style.setProperty('height', '100%', 'important');
    });
    
    // Apply flex direction to nmSaleTable
    if (nmSaleTable) {
      nmSaleTable.style.flexDirection = 'column';
    }

    // Loop through each nmSaleItem and apply styles
    nmSaleItems.forEach(function(item) {
      item.style.borderTop = '1px solid #333';  // !important can't be used directly in JS
    });

    // Apply border-bottom to .nm-noborder
    if (element) {
      element.style.borderBottom = '1px solid #333';
    }
  }
});

document.addEventListener("DOMContentLoaded", function() {
    // Find the select element
    var selectElement = document.getElementById("nm-wholesale-search-filter");

    // Check if selectElement exists before proceeding
    if (selectElement) {
        // Create a new arrow element
        var arrowElement = document.createElement("span");
        arrowElement.innerHTML = "&#9662;"; // ▼ Unicode arrow
        arrowElement.style.position = "absolute";
        arrowElement.style.pointerEvents = "none"; // Prevent click on the arrow
        arrowElement.style.right = "10px";
        arrowElement.style.top = "50%";
        arrowElement.style.transform = "translateY(-50%)";
        arrowElement.style.fontSize = "16px";
        arrowElement.style.color = "#333"; // Customize arrow color

        // Wrap the select element and arrow in a div
        var wrapper = document.createElement("div");
        wrapper.style.position = "relative";
        wrapper.style.display = "inline-block";

        // Insert wrapper in DOM and append the select and arrow inside it
        selectElement.parentNode.insertBefore(wrapper, selectElement);
        wrapper.appendChild(selectElement);
        wrapper.appendChild(arrowElement);
    } else {
        console.error("Select element with ID 'nm-wholesale-search-filter' not found.");
    }
});

document.addEventListener("DOMContentLoaded", function() {
    // Check if the current URL path is "/pages/bulk-order-form"
    if (window.location.pathname === "/pages/bulk-order-form") {
        // Select the h1 element with the specified class
        var titleElement = document.querySelector('.main-page-title');
        
        // Check if the element exists
        if (titleElement) {
            // Change the margin-bottom to 0
            titleElement.style.marginBottom = "0";
            titleElement.style.paddingBottom = "0";
        }
    }
  
});



// document.addEventListener("DOMContentLoaded", function() {
//     // Check if the customer is logged in
//     {% if customer %}
//         var targetElement = document.querySelector('#shopify-section-template--23506085478683__main');
//         if (targetElement) {
//             // Create a new div element
//             var newDiv = document.createElement('div');
            
//             // Add styles to the new div
//             newDiv.style.backgroundColor = "#e0f7fa"; // Light blue background
//             newDiv.style.color = "#0d47a1";           // Dark blue text
//             newDiv.style.textAlign = "center";        // Center text
//             newDiv.style.margin = "20px auto";        // Center div with margin auto
//             newDiv.style.padding = "10px";            // Add padding for spacing
//             newDiv.style.borderRadius = "8px";        // Rounded corners
            
//             // Add text to the new div
//             newDiv.innerText = "Wholesale pricing will automatically be added at checkout.";
//             newDiv.classList.add('wholesale-pricing-notify');

//             // Append the new div to the target element
//             targetElement.appendChild(newDiv);
//         }
//     {% endif %}
// });




// function updateAllPrices() {
//     // Select the price container
//     const priceDiv = document.querySelector('.nm-wholesale-header-price');
    
//     // Check if the priceDiv exists
//     if (priceDiv) {
//         // Select all span elements within the div
//         const priceSpans = priceDiv.querySelectorAll('span'); // Select all spans within the div
        
//         // Loop through each span and update its inner text
//         priceSpans.forEach(span => {
//             span.innerText = '100'; // Change the inner text to '999'
//         });
//     }
// }

// // Call the function to render the new price after DOM content is loaded
// document.addEventListener('DOMContentLoaded', function() {
//     updateAllPrices();
// });

